// extracted by mini-css-extract-plugin
module.exports = {"drag-bar":"DragBar_drag-bar__1fyXZ","open":"DragBar_open__2jDX-","drag-img":"DragBar_drag-img__2fFgs"};